<template>
  <div v-if="recipient" class="px-5 py-5">
    <Row>
      <Col cols="12" md="6">
        <strong>Nome:</strong> {{ recipient.name || '-' }}
      </Col>
      <Col cols="12" md="6">
        <strong>E-mail:</strong> {{ recipient.email || '-' }}
      </Col>
      <Col cols="12" md="6">
        <strong>Documento:</strong> {{ recipient.document || '-' }}
      </Col>
      <Col cols="12" md="6">
        <strong>Tipo:</strong> {{ getRecipientTypeLabel(recipient.type) }}
      </Col>
      <Col cols="12" md="6">
        <strong>Status:</strong> {{ recipient.status || '-' }}
      </Col>
      <Col cols="12" md="6">
        <strong>Modo de pagamento:</strong> {{ recipient.payment_mode || '-' }}
      </Col>
      <Col cols="12" md="6">
        <strong>ID:</strong> {{ recipient.id || '-' }}
      </Col>
      <Col cols="12" md="6">
        <strong>Descrição:</strong> {{ recipient.description || '-' }}
      </Col>
      <Col cols="12" md="6">
        <strong>Criado em:</strong> {{ formatDate(recipient.created_at) }}
      </Col>
      <Col cols="12" md="6">
        <strong>Atualizado em:</strong> {{ formatDate(recipient.updated_at) }}
      </Col>
    </Row>

    <ExpansionPanel
      v-if="recipient.default_bank_account"
      v-model="bankAccountPanel"
      title="Conta bancária padrão"
      :icon="$icons.financial"
      class="mt-4"
    >
      <Row>
        <Col cols="12" md="6">
          <strong>Titular:</strong>
          {{ recipient.default_bank_account.holder_name || '-' }}
        </Col>
        <Col cols="12" md="6">
          <strong>Documento do titular:</strong>
          {{ recipient.default_bank_account.holder_document || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Banco:</strong> {{ recipient.default_bank_account.bank || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Agência:</strong>
          {{ formatBankBranch(recipient.default_bank_account) }}
        </Col>
        <Col cols="12" md="4">
          <strong>Conta:</strong>
          {{ formatBankAccount(recipient.default_bank_account) }}
        </Col>
        <Col cols="12" md="6">
          <strong>Tipo:</strong> {{ recipient.default_bank_account.type || '-' }}
        </Col>
        <Col cols="12" md="6">
          <strong>Status:</strong> {{ recipient.default_bank_account.status || '-' }}
        </Col>
      </Row>
    </ExpansionPanel>

    <ExpansionPanel
      v-if="recipient.transfer_settings"
      v-model="transferSettingsPanel"
      title="Configurações de transferência"
      :icon="$icons.cashPlus"
      class="mt-4"
    >
      <Row>
        <Col cols="12" md="4">
          <strong>Transferência habilitada:</strong>
          {{ recipient.transfer_settings.transfer_enabled ? 'Sim' : 'Não' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Intervalo:</strong>
          {{ recipient.transfer_settings.transfer_interval || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Dia da transferência:</strong>
          {{ recipient.transfer_settings.transfer_day ?? '-' }}
        </Col>
      </Row>
    </ExpansionPanel>
  </div>
  <div v-else class="text-center py-6">
    Não foi possível carregar os dados do recebedor.
  </div>
</template>

<script>
import { ExpansionPanel, Row, Col } from '@/components/vuetify';
import { formatDatePT } from '@/utils';

const RECIPIENT_TYPE_LABELS = {
  individual: 'Pessoa Física',
  company: 'Pessoa Jurídica',
};

export default {
  name: 'AdminDistributorPagarmeRecipientTab',
  components: {
    ExpansionPanel,
    Row,
    Col,
  },
  props: {
    recipient: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      bankAccountPanel: 0,
      transferSettingsPanel: 0,
    };
  },
  methods: {
    formatDate(date) {
      return date ? formatDatePT(date) : '-';
    },
    getRecipientTypeLabel(type) {
      return RECIPIENT_TYPE_LABELS[type] || type || '-';
    },
    formatBankBranch(account) {
      if (!account?.branch_number) return '-';
      const digit = account.branch_check_digit ? `-${account.branch_check_digit}` : '';
      return `${account.branch_number}${digit}`;
    },
    formatBankAccount(account) {
      if (!account?.account_number) return '-';
      const digit = account.account_check_digit ? `-${account.account_check_digit}` : '';
      return `${account.account_number}${digit}`;
    },
  },
};
</script>
